import { Card, pn } from "@compass/core";
import { DevExpressReport, renderReportColumn } from "components";
import { ReportPropertyBase, StaffReportServiceSummaryResponse } from "generated/openApi";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const ServiceSummaryResponse = (props: { response: StaffReportServiceSummaryResponse }) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  const onExporting = () => {
    let infoTuples: [string, string | undefined][] = [];

    props.response.filterDisplays?.forEach((filterDisplay) => {
      infoTuples.push([
        `${filterDisplay.label!}${filterDisplay.operator ? ` (${filterDisplay.operator})` : ""}`,
        filterDisplay.values?.join(", "),
      ]);
    });

    return {
      header: "Service Summary Report",
      filename: "ServiceSummaryReport",
      tenantName: appTenantName,
      infoTuples: infoTuples,
    };
  };

  return (
    <Card header="Service Summary Report">
      <DevExpressReport
        dataSource={props.response.rows}
        exportFormats={["pdf", "excel", "csv"]}
        onExporting={onExporting}
      >
        {props.response.properties?.map((property) =>
          renderReportColumn({
            property: property,
            propertyKey: pn<ReportPropertyBase>("propertyName"),
          })
        )}
      </DevExpressReport>
    </Card>
  );
};
